// Reservierte Rückwege werden auch in fehlerhafter Schreibweise konsumiert,
// damit Codes weder in die allgemeine Navigation noch in deren History geraten.
export function isNativeOAuthReturn(rawUrl: string): boolean {
  try {
    const url = new URL(rawUrl);
    if (url.protocol === 'eu.fluesterfeder.app.oauth:') return true;
    const path = decodeURIComponent(url.pathname);
    return path === '/oauth/native/return' || path.startsWith('/oauth/native/return/');
  } catch { return false; }
}
